export const VIEW_TITLES = {
  dashboard: "Dashboard",
  calendar: "Calendar",
  templates: "Templates",
  export: "Export",
  projects: "Projects",
  "custom-fields": "Custom Fields",
  "notification-settings": "Notifications",
  blog: "Resources",
  referrals: "Refer & Earn",
  roadmap: "Roadmap",
  "demo-requests": "Demo Requests",
  slack: "Slack Integration",
  support: "Support",
  workload: "Workload",
  automations: "Automations",
  "support-tickets": "Support Tickets",
  "admin-insights": "Growth Insights",
  management: "Management",
  chat: "Team Chat",
  tutorial: "Video Tutorial",
  teams: "Teams",
  activity: "Activity",
  gantt: "Timeline",
};

export const VIEW_SUBTITLES = {
  dashboard: "Productivity insights",
  calendar: "Task schedule",
  "custom-fields": null,
  "notification-settings": "Email preferences & digest",
  blog: "Tips & guides",
  referrals: "Give a month, get a month",
  roadmap: "What we are building",
  "demo-requests": "Incoming requests",
  slack: "Connect your workspace",
  support: "Report an issue",
  workload: "Tasks grouped by assignee",
  automations: "Rules & email-to-task",
  "support-tickets": "Manage customer issues",
  export: "Export your data",
  chat: "Channels & direct messages",
  teams: "Manage your teams",
  gantt: "Plan on a timeline",
  management: "Admin control center",
  tutorial: "Watch how it works in 60 seconds",
};

export const SEO_TITLES = {
  board: "Tasks - Opero Smart Project Management",
  dashboard: "Dashboard - Opero Smart Analytics",
  calendar: "Calendar - Opero Smart Task Schedule",
  projects: "Projects - Opero Smart Project Management",
  templates: "Templates - Opero Smart",
  export: "Export - Opero Smart",
  "custom-fields": "Custom Fields - Opero Smart",
  "notification-settings": "Notifications - Opero Smart",
  blog: "Resources & Guides - Opero Smart",
  roadmap: "Product Roadmap - Opero Smart",
  "demo-requests": "Demo Requests - Opero Smart Admin",
  "support-tickets": "Support Tickets - Opero Smart Admin",
  "admin-insights": "Growth Insights - Opero Smart Admin",
  management: "Management - Opero Smart Admin",
  chat: "Team Chat - Opero Smart",
  workload: "Workload - Opero Smart Team View",
  automations: "Automations - Opero Smart",
};
